import React from "react";
import ReactDOM from "react-dom/client";

import { CookiesProvider } from "react-cookie";
import { QueryClientProvider } from "./QueryClientProvider";
import { Toaster } from "react-hot-toast";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "./sentry";

import "./index.css";
import { Router } from "./router";
import { APIsProvider } from "./api";
import { AuthProvider } from "./Auth";
import { TooltipProvider } from "./components/Tooltip";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Toaster />
    <TooltipProvider>
      <CookiesProvider>
        <QueryClientProvider>
          <ReactQueryDevtools initialIsOpen={false} />
          <APIsProvider>
            <AuthProvider>
              <Router />
            </AuthProvider>
          </APIsProvider>
        </QueryClientProvider>
      </CookiesProvider>
    </TooltipProvider>
  </React.StrictMode>,
);
